import { createStandardAction } from 'typesafe-actions';

import type { SeoData } from 'Seo-Types';

export const updateSEOData = createStandardAction('UPDATE_SEO_DATA').map((payload: SeoData) => ({
  payload,
}));

export const setDefaultSEOData = createStandardAction('SET_DEFAULT_SEO_DATA').map(() => ({
  payload: {},
}));
